import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {AddUserDialog} from '../user-add.dialog';
import {FourDService, Project} from '4d-mapper';
import {AppService} from '../../../commons/app.service';
import {forkJoin} from 'rxjs';
import {AppBaseComponent} from '../../../commons/AppBaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import { XsApplicationEventsService } from '../../../xs/services/events/application-events.service';

@Component({
  selector: 'app-share-project',
  templateUrl: './share-project-dialog.component.html',
  styleUrls: ['./share-project-dialog.component.scss']
})
export class ShareProjectDialog extends AppBaseComponent implements OnInit, OnDestroy {
  shareAll: boolean;

  constructor(public dialogRef: MatDialogRef<ShareProjectDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public fourD: FourDService, public service: AppService, public router: Router,
              public snackBar: MatSnackBar, public dialog: MatDialog, private activeRoute: ActivatedRoute, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);
  }


  ok() {
    if (this.data.projects.length > 0 && this.shareAll !== undefined) {
      this.loading = true;
      forkJoin(this.data.projects.map(project => {
        if (this.shareAll == false) {
          return project.shareUsers.removeObservable(this.data.user)
        } else if (this.shareAll == true) {
          return project.shareUsers.addObserveable(this.data.user)
        }
      })).subscribe(_ => {
        this.openSnackBarSuccess('USER_ADMIN.PROJECT_SHARED');
        this.loading = false;
        this.dialogRef.close();
      })

    } else {
      this.dialogRef.close();
    }
  }

  cancel() {
    this.dialogRef.close()
  }

  shareProject(checked: any, project: Project) {
    this.shareAll = undefined;
    if (checked) {
      project.shareUsers.addObserveable(this.data.user).subscribe();
      if (!this.data.user['projects']) {
        this.data.user['projects'] = [];
      }
      if (this.data.user['projects'].indexOf(project) === -1) {
        this.data.user['projects'].push(project);
      }
    } else {
      project.shareUsers.removeObservable(this.data.user).subscribe();
      if (this.data.user['projects'].indexOf(project) !== -1) {
        this.data.user['projects'].splice(this.data.user['projects'].indexOf(project), 1);
      }
    }
  }

  shareAllProjects(event) {
    this.data.user['projects'] = [];
    if (event.checked) {
      this.data.projects.forEach(project => {
        this.data.user['projects'].push(project);
      })
    }
  }
}
